export default __webpack_public_path__ + "static/media/star.ec772153.svg";